import { useCallback, useState } from "react";

export default function useSessionStorage<T>(
  key: string,
  initialValue: T
): {
  sessionValue: T;
  setSessionItem: (x: T) => void;
  removeSessionItem: () => void;
} {
  const [sessionValue, setSessionValue] = useState<T>(() => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  });

  const setSessionItem = useCallback(
    (value: T): void => {
      try {
        const valueToStore =
          typeof value === "function"
            ? (value as (val: T) => T)(sessionValue)
            : value;
        // Save state
        setSessionValue(valueToStore);
        // Save to session storage
        sessionStorage.setItem(key, JSON.stringify(valueToStore));
      } catch (error) {
        console.error(error);
      }
    },
    [key, sessionValue]
  );

  const removeSessionItem = useCallback((): void => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  }, [key]);

  return { sessionValue, setSessionItem, removeSessionItem };
}
